import angular from 'angular';
import './css/allMenus.css';
import { MenuService } from './menuService';
import menuComponent from './menuComponent';
import menuBreadcrumbsComponent from './breadcrumbs/menuBreadcrumbsComponent';

angular
	.module('sh.menu', ['sh.api'])
	.service('Menu', MenuService)
	// <sh-menu name="headerNav">
	.directive('shMenu', menuComponent)
	.directive('shMenuBreadcrumbs', menuBreadcrumbsComponent);
